import 'src/shared/FormAnswer/Form/Section/Section.scss'
import * as React from 'react'
import { Typography, Theme, createStyles, WithStyles, withStyles, Icon, CircularProgress, Grid } from '@material-ui/core'
import {connect} from 'react-redux'
import { ISection } from 'src/shared/FormAnswer/types/Section'
import { IMessages } from 'src/shared/FormAnswer/types/Messages'
import { Question } from 'src/shared/FormAnswer'
import { IQuestion, QuestionId, QuestionType } from 'src/type/form/question'
import { IForm } from 'src/type/form/form'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { IAnswer } from 'src/shared/FormAnswer/types/Answer'
import Btn from 'src/shared/Btn/Btn'
import { formAction } from 'src/core/redux/action/formAction'
import autobind from 'autobind-decorator'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import {isEmpty} from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router'
import PcDialog from 'src/shared/Dialog/PcDialog'
import { colorSuccess } from 'src/shared/style/color'
import {css} from 'src/conf/style'

export interface ExpensionStepProps {
  readonly isLast: boolean;
  readonly index: number;
  readonly prev: () => void;
  readonly next: () => void;
}

const styles = (t: Theme) => createStyles({
    titleLv1: {
        ...css.flexAlCenter,
        margin: `${t.spacing.unit * 3}px 0 0 ${t.spacing.unit * 3}px`,
        fontWeight: 'bold'
    },
    captionLv1: {
        margin: `0 0 0 ${t.spacing.unit * 3}px`,
        paddingTop: `${t.spacing.unit * 2}px`,
        borderTop: '2px solid #ED1C24',
        fontStyle: 'italic'
    },
    questionPrincipal: {
        padding: '.5rem .5rem 1rem .5rem',
        background: '#f4f4f4',
        marginBottom: '1rem',
        borderBottom: '2px dotted #C1C7D0'
    },
    questionLv1: {
        margin: `0 0 ${t.spacing.unit * 3}px ${t.spacing.unit * 3}px`
    },
    formContent: {
        position: 'relative',
        margin: `${t.spacing.unit * 2}px 0`,
        padding: `${t.spacing.unit}px`,
    },
    formActions:{
        display: 'flex',
        justifyContent: 'flex-end'
    },
    btnCloseForm: {
        position: 'absolute',
        right: 0,
        top: 0,
        margin: '0.5rem',
        fontSize: '2rem',
        cursor: 'pointer'
    }
});

interface Props extends WithStyles<typeof styles>,
WithI18n,
WithToast,
ReturnType<typeof state2Props>,
ReturnType<typeof dispatch2props>,
RouteComponentProps<any>  {
  readonly form: IForm;
  readonly section: ISection;
  readonly isFormValid: boolean;
  readonly answers: any;
  readonly messages: IMessages;
  readonly readonly: boolean;
  readonly checkedPossibilityIds: any;
}

class FormToAnswer extends React.Component<Props & ExpensionStepProps, {}> {
    state = {
        modalAlertRedirect: false
    }

  render() {
    const {form, classes, sectionsValidity, readonly, t, isSaving} = this.props;
    return (
      <main>
        {form &&
            <>
                <Typography variant="h6" align="center" gutterBottom>{form.name}</Typography>
                <Typography variant="caption" align="center" style={{fontStyle: 'italic', padding: '0 5rem'}} gutterBottom>{form.description}</Typography>
                <div className={classes.formContent}>
                {
                    form.sections.map(s => {
                        return (
                            <div key={s.id}>  
                                {this.showQuestion(this.getQuestionByIndex(0, s.questions)) &&
                                    <div className={classes.questionPrincipal}>
                                        <Question key={0} inline={true} important={true} question={this.getQuestionByIndex(0, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(1, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Obligations et titres de créance</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={1} inline={true} question={this.getQuestionByIndex(1, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(2, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={2} inline={true} question={this.getQuestionByIndex(2, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(3, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Produits structurés complexes‌</Typography>
                                        <Typography variant="caption" className={classes.captionLv1}>Selon vous, les affirmations qui suivent sont-elles vraies ou fausses ?</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={3} inline={true} question={this.getQuestionByIndex(3, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(4, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={4} inline={true} question={this.getQuestionByIndex(4, s.questions)}/>
                                    </div>    
                                }
                                {this.showQuestion(this.getQuestionByIndex(5, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={5} inline={true} question={this.getQuestionByIndex(5, s.questions)}/>
                                    </div>    
                                }
                                {this.showQuestion(this.getQuestionByIndex(6, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={6} inline={true} question={this.getQuestionByIndex(6, s.questions)}/>
                                    </div>    
                                }
                                {this.showQuestion(this.getQuestionByIndex(7, s.questions)) &&
                                    <div className={classes.questionPrincipal}>
                                        <Question key={7} inline={true} important={true}  question={this.getQuestionByIndex(7, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(8, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Change ferme (change à terme sec et à préavis, swap de change)</Typography>
                                        <Typography variant="caption" className={classes.captionLv1}>Selon vous, les affirmations qui suivent sont-elles vraies ou fausses ?</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={8} inline={true} question={this.getQuestionByIndex(8, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(9, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={9} inline={true} question={this.getQuestionByIndex(9, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(10, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={10} inline={true} question={this.getQuestionByIndex(10, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(11, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={11} inline={true} question={this.getQuestionByIndex(11, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(12, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Change conditionnel (option de change vanille, à barrière(s), montage d’options, terme accumulateur …)</Typography>
                                        <Typography variant="caption" className={classes.captionLv1}>Selon vous, les affirmations qui suivent sont-elles vraies ou fausses ?</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={12} inline={true} question={this.getQuestionByIndex(12, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(13, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={13} inline={true} question={this.getQuestionByIndex(13, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(14, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={14} inline={true} question={this.getQuestionByIndex(14, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(15, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={15} inline={true} question={this.getQuestionByIndex(15, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(16, s.questions)) &&
                                    <div className={classes.questionPrincipal}>
                                        <Question key={16} inline={true} important={true}  question={this.getQuestionByIndex(16, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(17, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Taux ferme (swap de taux, FRA, …)</Typography>
                                        <Typography variant="caption" className={classes.captionLv1}>Selon vous, les affirmations qui suivent sont-elles vraies ou fausses ?</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={17} inline={true} question={this.getQuestionByIndex(17, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(18, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                    <Question key={18} inline={true} question={this.getQuestionByIndex(18, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(19, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={19} inline={true} question={this.getQuestionByIndex(19, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(20, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={20} inline={true} question={this.getQuestionByIndex(20, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(21, s.questions)) &&
                                    <>
                                        <Typography variant="subtitle1" className={classes.titleLv1}>Taux conditionnel (swap de taux semi-fixe, à pallier, annulable, cap, floor et collar)</Typography>
                                        <Typography variant="caption" className={classes.captionLv1}>Selon vous, les affirmations qui suivent sont-elles vraies ou fausses ?</Typography>
                                        <div className={classes.questionLv1}>
                                            <Question key={21} inline={true} question={this.getQuestionByIndex(21, s.questions)}/>
                                        </div>
                                    </>
                                }
                                {this.showQuestion(this.getQuestionByIndex(22, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={22} inline={true} question={this.getQuestionByIndex(22, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(23, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={23} inline={true} question={this.getQuestionByIndex(23, s.questions)}/>
                                    </div>
                                }
                                {this.showQuestion(this.getQuestionByIndex(24, s.questions)) &&
                                    <div className={classes.questionLv1}>
                                        <Question key={24} inline={true} question={this.getQuestionByIndex(24, s.questions)}/>
                                    </div>
                                }
                            </div>
                        )
                    })
                }
                </div>
                
                <Typography variant="caption" style={{fontStyle: 'italic'}} gutterBottom>
                    Nous vous invitons à signer le document ci-après qui contient les réponses du questionnaire personne que vous venez de compléter. 
                    Veuillez vous munir du téléphone avec le numéro suivant <span style={{fontWeight: 'bold'}}>{this.props.connectedUser.phone}</span> (un SMS de confirmation va vous être envoyé)
                </Typography>

                <br />
                <div className={classes.formActions}>
                {!readonly && isEmpty(sectionsValidity) === false &&
                    <Btn
                        disabled={!this.isValid(sectionsValidity[form.sections[0].id])}
                        onClick={this.save}
                        variant='contained'
                        color='primary'
                        loading={isSaving}
                        >
                        {t.save}
                    </Btn>
                }
                </div>

                <PcDialog
                    open={this.state.modalAlertRedirect}
                >
                    <Grid container direction="row" justify="center" alignItems="center" wrap="nowrap">
                        <Icon style={{color: colorSuccess, marginRight: '5px'}}>check_circle</Icon>
                        <span>{t.formanswers_save_success}</span>
                    </Grid>
                    <Grid container direction="row" justify="center">
                        <CircularProgress size={34} />
                    </Grid>
                </PcDialog>
            </>
        }
      </main>
    );
  }
  

  componentWillMount() {
    this.initReducerParams();
    this.initReducerAnswers();
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.form !== prevProps.form){
        this.initReducerAnswers();
    }
  }

  private initReducerParams() {
    const {t, initFormParams} = this.props
    initFormParams({
      dateFormat: 'dd/MM/yyyy',
      messages: {
        buttonNext: t.formanswers_messages_next,
        buttonEnd: t.formanswers_messages_end,
        buttonPrevious: t.formanswers_messages_previous,
        upload: t.formanswers_messages_upload,
        invalidFileSize: t.formanswers_messages_invalidFileSize,
        invalidDate: t.formanswers_messages_invalidDate,
        invalidText: t.formanswers_messages_invalidText,
        invalidPattern: t.formanswers_messages_invalidPattern,
        noFile: t.formanswers_empty
      },
      maxUploadFileSize: 20000,
      triggerOnChange: this.onChange,
      onUploadFile: this.onUploadFile,
      readonly: false,
    });
  }


  @autobind
  onUploadFile(){
      // do something
  }

  private initReducerAnswers() {
    const {form, resetAnswers, updateAnswer} = this.props;
    resetAnswers();
    if(form !== null){
        form.sections.forEach(s => s.questions.forEach(q => {
            if (q.question_type === QuestionType.LABEL)return;
            updateAnswer(q.id, q.answers);
        }));
    }
  }

  private save = () => {
    const {saveAnswer, enterprise, toastError, form} = this.props
    const formAnswers = this.parseAnswers(this.getSectionAnswers(0))
    const finalAnswers =  this.cleanHiddenAnswers(form, formAnswers)
    saveAnswer(enterprise.id, 1, finalAnswers).then(res => {   
        this.setState({modalAlertRedirect: true})
        setTimeout(() => {
            this.setState({modalAlertRedirect: false})
            window.location.href = res
        }, 2000);
    }).catch(err =>{
        if(err.msg) toastError(err.msg)
    })
  }

  private generateMockAnswer = (form: IForm) => {
      return form.sections[0].questions.map(question => ({
          question_id: question.id,
          answer: []
      }))
  }

  /* 
    Need to clean hidden answers before submit when we toggle Yes/No on these questions principal
  */
  private cleanHiddenAnswers = (form: IForm, answers: IAnswer[]) => {
    const QUESTIONS_CHECK = [form.sections[0].questions[0].id, form.sections[0].questions[7].id, form.sections[0].questions[16].id]
    const QUESTIONS_GROUPED = {
        [form.sections[0].questions[0].id] : {
            subQuestionIds: [
                form.sections[0].questions[1].id,
                form.sections[0].questions[2].id,
                form.sections[0].questions[3].id,
                form.sections[0].questions[4].id,
                form.sections[0].questions[5].id,
                form.sections[0].questions[6].id
            ]
        },
        [form.sections[0].questions[7].id] : {
            subQuestionIds: [
                form.sections[0].questions[8].id,
                form.sections[0].questions[9].id,
                form.sections[0].questions[10].id,
                form.sections[0].questions[11].id,
                form.sections[0].questions[12].id,
                form.sections[0].questions[13].id,
                form.sections[0].questions[14].id,
                form.sections[0].questions[15].id
            ]
        },
        [form.sections[0].questions[16].id] : {
            subQuestionIds: [
                form.sections[0].questions[17].id,
                form.sections[0].questions[18].id,
                form.sections[0].questions[19].id,
                form.sections[0].questions[20].id,
                form.sections[0].questions[21].id,
                form.sections[0].questions[22].id,
                form.sections[0].questions[23].id,
                form.sections[0].questions[24].id
            ]
        }
    }
    const mockAnswers = this.generateMockAnswer(form)
    const mappingAnswer = answers.reduce((obj, a) => ({ ...obj, [a.question_id]: a.answer }), {})
    QUESTIONS_CHECK.map(i => {
        const answers_check = answers.find(a => a.question_id === i)
        const question = mockAnswers.find(c => c.question_id === i)
        if(!!question) {
            question.answer = !!mappingAnswer[i] ? mappingAnswer[i] : []   // recopy answer form mapping answer to mock answer     
        }           
        if(!!answers_check && answers_check.answer.length === 1 && answers_check.answer[0] === 'Oui') {
            QUESTIONS_GROUPED[i].subQuestionIds.map(sId => {
                const question = mockAnswers.find(c => c.question_id === sId)
                if(!!question) {
                    question.answer = !!mappingAnswer[sId] ? mappingAnswer[sId] : [] // recopy answer form mapping answer to mock answer
                }
            })
        } 
    })
    return mockAnswers
  }

  private getSectionAnswers(sectionIndex: number): { [key: string]: string[] } {
    const {answers} = this.props;
    const sectionQuestionIds = this.props.form.sections[sectionIndex].questions.map(q => q.id);
    return Object.keys(answers).filter(key => sectionQuestionIds.includes(key)).reduce((obj, key) => {
      obj[key] = answers[key];
      return obj;
    }, {});
  }

  private onChange = (questionIdAnswered: QuestionId) => {
      // do not auto-save
  }

  private parseAnswers = (answers: { [key: string]: string[] }): IAnswer[] => {
    return Object.keys(answers).map((k: string) => this.parseAnswer(k, answers[k])).filter((v: any) => v);
  };

  private parseAnswer = (id: string, answer: string[]): IAnswer | null => {
    return answer ? {question_id: id, answer} : null
  };

  private getQuestionByIndex(index: number, questions: any){
    return questions.find(q => q.index === index);
  }

  private showQuestion(q: IQuestion) {
    const {checkedPossibilityIds} = this.props;
    if (q !== undefined && q.possibility_id_dep === undefined) {
        return true;
    } else {
        for (const k in checkedPossibilityIds) {
            if (checkedPossibilityIds[k] === q.possibility_id_dep) return true;
        }
        return false;
    }
  }

  private isValid(validity: { [key: string]: boolean }): boolean {
    return validity ? Object.keys(validity).map(key => validity[key]).every(v => !!v) : false
  }
}



const state2Props = (state) => ({
  sectionsValidity: state.formAnswer.sectionsValidity,
  answers: state.formAnswer.answers,
  isSaving: state.formAnswer.isSaving,
  form: state.formAnswer.form,
  messages: state.formAnswer.messages,
  readonly: state.formAnswer.readonly,
  checkedPossibilityIds: state.formAnswer.checkedPossibilityIds,
  enterprise: state.accountInfo.enterpriseSelected,
  connectedUser: state.accountInfo.connectedUser,
});

const dispatch2props = dispatch => ({
    fetchForm: (id: string, version: number) => dispatch(formAction.fetchForm(id, version)),
    initFormParams: (params: any) => dispatch(formAction.init(params)),
    resetAnswers: () => dispatch(formAction.resetAnswers()),
    updateAnswer: (questionId: QuestionId, answer: string[]) => dispatch(formAction.updateAnswer(questionId, answer)),
    saveAnswer: (id: string, version: number, answers: any)  => dispatch(formAction.saveAnswer(id, version, answers))
});


export default compose(
    withI18n,
    withStyles(styles), 
    withToast,
    withRouter,
    connect(state2Props, dispatch2props)
)(FormToAnswer);



// WEBPACK FOOTER //
// ./src/shared/FormArkea/FormToAnswer.tsx